import { createSelector } from 'reselect';
import { DOC_TYPE_TITLE } from 'constants/orders';

export const ordersSelector = (state) => state.orders.items || [];
export const sessionSelector = (state) => state.session || {};
export const orderIdSelector = (state) => state.orders.activeOrder || null;

export const activeOrderSelector = createSelector(
  [orderIdSelector, ordersSelector],
  (orderId, orders) => orders.find(({ id }) => orderId === id)
);

export const titleSelector = createSelector(
  [activeOrderSelector],
  (order) =>
    order &&
    order.documents &&
    order.documents.find(({ type }) => type === DOC_TYPE_TITLE)
);

export const userSelector = createSelector(
  [sessionSelector],
  ({ last_name, first_name, mobile_number, business_name, email_address }) => ({
    last_name: last_name || '',
    first_name: first_name || '',
    mobile_number: mobile_number || '',
    email_address: email_address || '',
    business_name: business_name || ''
  })
);
